import { OneTimePasscodeStatus } from '@interfaces/one-time-passcode/otp.interface';
import { Action, createReducer, on } from '@ngrx/store';
import { UpdateOTPVerification } from '@store/actions/otp/otp.actions';

export interface OneTimePasscodeState {
  verified: OneTimePasscodeStatus;
}
export const initialState: OneTimePasscodeState = {
  verified: OneTimePasscodeStatus.UNKNOWN,
};
const oneTimePasscodeReducer = createReducer(
  initialState,
  on(UpdateOTPVerification, (state, { payload }) => {
    return {
      ...state,
      verified: payload,
    };
  }),
);
export function reducer(state: OneTimePasscodeState | undefined, action: Action) {
  return oneTimePasscodeReducer(state, action);
}

export const getOTPStatus = (state: OneTimePasscodeState): OneTimePasscodeStatus => state.verified;
